import axios from "axios";
import Button from "components/button/default";
import { useBookInfContext } from "components/context/bookInfContext";
import { useEffect, useState } from "react";
import { alertControl } from "util/commAction";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./pay.scss";

type IProps = {
  handleClose(): void;
};

export default function ModalPayInnner({ handleClose }: IProps) {
  const { t } = useTranslation();
  const { onBkStep } = useBookInfContext();
  const { pathname } = useLocation();
  const [payRgSeq, setPayRgSeq] = useState("");

  const handlePay = async () => {
    await axios
      .get(`/app/api/pay/payChk/${payRgSeq}`)
      .then((res) => {
        const {
          status: { code, dtlCode, message },
          data,
        } = res.data;
        if (code === 0) {
          alertControl({
            isOpen: true,
            inner: t("alr_pay_done"),
            click: () => {
              handleClose();
              if (!pathname.includes("sample")) {
                onBkStep(4);
              }
              if (pathname.includes("sample")) {
                onBkStep(3);
              }
            },
          });
        }
        if (code === -1) {
          handleClose();
          alertControl({
            isOpen: true,
            inner: message,
          });
        }
        if (dtlCode === "Q004") {
          handleClose();
          alertControl({
            isOpen: true,
            inner: t("alr_pay_cancel"),
            click: () => {
              handleClose();
            },
          });
        }
      })
      .catch((error: any) => {
        console.error(error);
        handleClose();
      })
      .finally(() => {});
  };

  const handleCancelPay = async () => {
    await axios
      .get(`/app/api/pay/payChk/${payRgSeq}`)
      .then((res) => {
        const {
          status: { code, dtlCode, message },
          data,
        } = res.data;
        if (code === 0) {
          handleClose();
          alertControl({
            isOpen: true,
            inner: t("alr_pay_done"),
            click: () => {
              handleClose();
              if (!pathname.includes("sample")) {
                onBkStep(4);
              }
              if (pathname.includes("sample")) {
                onBkStep(3);
              }
            },
          });
        }
        if (code === -1) {
          handleClose();
          alertControl({
            isOpen: true,
            inner: message,
          });
        }
        if (dtlCode === "Q004") {
          alertControl({
            isOpen: true,
            inner: t("alr_pay_cancel"),
            click: () => {
              handleClose();
            },
          });
        }
      })
      .catch((error: any) => {
        console.error(error);
        handleClose();
      })
      .finally(() => {
        console.log("finally");
      });
  };

  useEffect(() => {
    if (window) {
      window.addEventListener(
        "message",
        (e: MessageEvent<any>) => {
          if (window.location.origin !== e.origin) {
            return;
          }

          if (e.data) {
            const { payRgSeq, resCode, resMsg } = e.data;
            if (!!payRgSeq) {
              setPayRgSeq(e.data.payRgSeq);
              localStorage.setItem("payRgSeq", payRgSeq);
            }

            if (resCode === "XXXX") {
              alertControl({
                isOpen: true,
                // inner: resMsg,
                inner: "결제취소",
                click: () => {
                  handleClose();
                },
              });
            }
            if (resCode === "0000") {
              handleClose();
              if (!pathname.includes("sample")) {
                onBkStep(4);
              }
              if (pathname.includes("sample")) {
                onBkStep(3);
              }
            }
          }
        },
        false
      );
    }

    // return () => {
    //   window.removeEventListener("message", () => {});
    // };
  }, []);

  return (
    <div className="portal flex-col center">
      <div className="">
        <div className="loader"></div>
      </div>
      <div className="py-4">{t("txt_pay_doing")}</div>
      <div className=" py-6 ">
        <Button text={t("btn_pay_done")} styels="mb-6" onClick={handlePay} />
        <Button text={t("btn_pay_cancel")} onClick={handleCancelPay} />
      </div>
    </div>
  );
}
